import React from 'react'
import {t} from 'i18next'
import {toast} from 'components/Toast'

type ErrorBoundaryProps = {
    children: React.ReactElement | null
}

type ErrorBoundaryState = {
    error: boolean
}

class ErrorBoundary<ChildErrorBoundaryProps> extends React.PureComponent<ErrorBoundaryProps & ChildErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps & ChildErrorBoundaryProps) {
        super(props)

        this.state = {error: false}
    }

    // eslint-disable-next-line class-methods-use-this
    componentDidCatch(_error: Error) {
        toast.error(t('Something went wrong'))
    }

    static getDerivedStateFromError(_error: Error) {
        return {error: true}
    }

    render() {
        const {children} = this.props
        const {error} = this.state

        if (error) {
            return null
        }

        return children
    }
}

export default ErrorBoundary
